export default "<svg class=\"icon-svg\" [ngClass]=\"iconClass\"> \n    <use attr.xlink:href=\"{{urlIcon}}#{{icon}}\"></use> \n</svg>"